var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-analysis-page__container"},[_c('VisualAnalysisPageHeader'),(_vm.isVisualCreated)?[_c('VisualAnalysisChart'),_c('VisualAnalysisTable')]:_c('EmptyAnalysisPlaceholder')],2)}
var staticRenderFns = []

export { render, staticRenderFns }